import { SystemStyleObject } from "@chakra-ui/react";

const READONLY_STYLES = {
  bg: "rgba(226,232,240, 0.2)",
  border: "var(--chakra-colors-chakra-border-color) 1px solid !important",
  cursor: "default",
};

export const READONLY_SX_STYLES: SystemStyleObject = {
  "textarea:read-only": READONLY_STYLES,
  "input:read-only": READONLY_STYLES,
};
